import ReactDateRangePicker from "components/ReactDateRangePicker/ReactDateRangePicker";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WhiteButton } from "styledComponents/buttons";

import avatar5 from "../../assets/img/avatar_5.svg";
import LeftArrow_3 from "../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../assets/img/icons/RightArrow_3.svg";
import ProjectDropdown from "../../components/CommonFilter/ProjectDropdown";
import AddSingleMemberDropdown from "../../components/CustomDropdown/AddSingleMemberDropdown";
import CreateProjectDropdown from "../../components/DropdownStyle/CreateProjectDropdown";
import FilterDropDownStyle from "../../components/DropdownStyle/FilterDropDownStyle";
import Select from "../../components/ReactSelectDropdown";
import { filterOption } from "../../components/ReactSelectDropdown/ReactSelectDropdown";
import SearchWithButton from "../../components/Search/SearchWithButton";
import ClearFilterButton from "../../components/Search/clearFilterButton";
import DatePicker from "../../components/SingleDatePicker/SingleDatePicker";
import HelperIcon from "../../components/HelperIcon/HelperIcon";
import {
  CommonFlex,
  CommonFlexWrap,
  CommonImage,
  Container,
  FilterLabel,
  IconArrow,
  InputField,
  InputWithLabelSection,
} from "../../styledComponents/common";
import { FilterContainer } from "../../styledComponents/tasks";

const JobFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  selectedMember,
  selectProject,
  selectMember,
  clearMember,
  taskStatus,
  handleStatusChange,
  handleSearchByName,
  handleClearSearch,
  searchTerm,
  onSearchTermChange,
  workOrderShortList,
  getWorkOrderShortList,
  selectedWorkOrder,
  setSelectedWorkOrder,
  selectWorkOrder,
  selectToday,
  singleDateChange,
  startDate,
  endDate,
  onDateSelect,
  selectLastWeek,
  selectLastMonth,
  selectNextWeek,
  changeDateRange,
  dateLabel,
}) => {
  const { t } = useTranslation();

  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperation = orgType === "operation";

  const [officeOptions, setOfficeOptions] = useState([
    {
      label: `(${t("all_teams")})`,
      value: null,
    },
  ]);
  const [workOrderOptions, setWorkOrderOptions] = useState([
    {
      label: `(${t("all_projects")})`,
      value: null,
    },
  ]);

  const [memberOptions, setMemberOptions] = useState([]);
  const statusOptions = [
    {
      label: `(${t("All except later")})`,
      value: "all",
    },
    {
      value: "unscheduled",
      label: t("later"),
    },
    {
      value: "scheduled",
      label: t("now"),
    },
    {
      value: "completed",
      label: t("completed_all"),
    },
    {
      value: "approved",
      label: t("completed_approved"),
    },
    {
      value: "pending",
      label: t("completed_pending"),
    },
    {
      value: "missed",
      label: t("missed"),
    },
  ];

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      getWorkOrderShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersList({ organization_id: selectedOrganization.id });
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (workOrderShortList && workOrderShortList.length > 0) {
      let newArr = [
        {
          label: `(${t("all_projects")})`,
          value: null,
        },
      ];
      workOrderShortList.forEach((workorder, i) => {
        newArr.push({
          label: workorder.name,
          value: workorder.id,
        });
      });
      setWorkOrderOptions(newArr);
    }
  }, [workOrderShortList, orgType, t]);

  const onMemberSelect = person => {
    selectMember(person);
  };

  const clearSelectedMember = () => {
    clearMember();
  };

  // console.log('taskStatus?.value:', taskStatus?.value);
  return (
    <CommonFlexWrap
      admin={
        selectedOrganization &&
        selectedOrganization.role &&
        (selectedOrganization.role === "admin" ||
          selectedOrganization.role === "owner")
      }
    >
     {isOperation && (
       <InputWithLabelSection>
        <FilterLabel>
          {t("project")}
        </FilterLabel>
        <Select
          isSearchable
          isClearable={selectedWorkOrder?.value}
          value={selectedWorkOrder}
          options={workOrderOptions}
          placeholder="Select WorkOrder..."
          onChange={e => {
            e
              ? selectWorkOrder(e)
              : selectWorkOrder({
                  label: `(${t(
                    "all_projects",
                  )})`,
                  value: null,
                });
          }}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
          components={{
            IndicatorSeparator: () => null,
            ClearIndicator: props => {
              return <ClearFilterButton {...props} />;
            },
          }}
        />
      </InputWithLabelSection>)}

      {selectedOrganization &&
        selectedOrganization.role &&
        (selectedOrganization.role === "admin" ||
          selectedOrganization.role === "owner") && (
          <InputWithLabelSection>
            <FilterLabel>{t("assignee")}</FilterLabel>
            <div style={{ width: `40px` }}>
              <AddSingleMemberDropdown
                assigneeManage={selectedMember}
                updateState={onMemberSelect}
                membersList={organizationMembersList}
                clearAssignee={() => clearMember()}
                page={"jobs"}
                closeDisabled={true}
              />
            </div>
          </InputWithLabelSection>
        )}

      <SearchWithButton
        itemName={t(orgType === "service" ? "job" : "task")}
        searchTermName={t(orgType === "service" ? "job_name" : "task_name")}
        searchInput={searchTerm}
        onInputChange={onSearchTermChange}
        handleSearch={handleSearchByName}
        handleClearSearch={handleClearSearch}
      />

      <CommonFlex  gap="4px" alignItems="end">
        <InputWithLabelSection>
          <CommonFlex gap="4px" alignItems="center" disabledResponsive>
            <FilterLabel>
              {t("date_range")}
              {` (${
                taskStatus?.value === "unscheduled"
                  ? "NA for Unscheduled"
                  : dateLabel
              })`}
            </FilterLabel>
            <HelperIcon text={t(orgType === "service" ? "choose_date_range_for_jobs_data" : "choose_date_range_for_tasks_data")} />
          </CommonFlex>
          <ReactDateRangePicker
            startDate={startDate ? moment(startDate) : null}
            startDateId="report-date-range-start-date"
            endDate={endDate ? moment(endDate) : null}
            endDateId="report-date-range-end-date"
            onDatesChange={changeDateRange}
            onDateSelect={onDateSelect}
            selectLastWeek={selectLastWeek}
            selectLastMonth={selectLastMonth}
            selectNextWeek={selectNextWeek}
            rangeRestricted={true}
            disableFutureDates={false}
            disabled={taskStatus?.value === "unscheduled"}
          />
        </InputWithLabelSection>

        <IconArrow
          onClick={() => {
            taskStatus?.value !== "unscheduled" && singleDateChange("left");
          }}
          disabled={taskStatus?.value === "unscheduled"}
          padding="5px"
          size="39px"
          src={LeftArrow_3}
        />
        <IconArrow
          onClick={() => {
            taskStatus?.value !== "unscheduled" && singleDateChange("right");
          }}
          disabled={taskStatus?.value === "unscheduled"}
          padding="5px"
          size="39px"
          src={RightArrow_3}
        />
        <WhiteButton
          type="nav"
          borderRadius="6px"
          style={{
            height: "38px",
            padding: "0px 15px",
          }}
          onClick={taskStatus?.value !== "unscheduled" && selectToday}
          disabled={taskStatus?.value === "unscheduled"}
        >
          Today
        </WhiteButton>
      </CommonFlex>

      <InputWithLabelSection >
        <CommonFlex gap="4px" alignItems="center" disabledResponsive>
          <FilterLabel>{t("status")}</FilterLabel>
          <HelperIcon text={t(orgType === "service" ? "choose_status_of_jobs_to_view" : "choose_status_of_tasks_to_view")} />
        </CommonFlex>
        <Select
          isSearchable={false}
          isClearable={taskStatus?.value !== "all"}
          value={taskStatus}
          options={statusOptions}
          placeholder="Select Status..."
          onChange={e => {
            e
              ? handleStatusChange(e)
              : handleStatusChange({
                  label: `(${t("All except unscheduled")})`,
                  value: "all",
                });
          }}
          styles={FilterDropDownStyle({
            height: "40px",
            width: "150px",
            menuWidth: "130px",
          })}
          components={{
            IndicatorSeparator: () => null,
            ClearIndicator: props => {
              return <ClearFilterButton {...props} />;
            },
          }}
        />
      </InputWithLabelSection>
    </CommonFlexWrap>
  );
};

export default JobFilter;
